export const CREATE_OR_UPDATE_ORDER = "CREATE_OR_UPDATE_ORDER"
export const CREATE_OR_UPDATE_ORDER_SUCCESS = "CREATE_OR_UPDATE_ORDER_SUCCESS"

export const GET_ORDER = "GET_ORDER"
export const GET_ORDER_SUCCESS = "GET_ORDER_SUCCESS"

export const CREATE_OR_UPDATE_ORDER_API_ERROR = "CREATE_OR_UPDATE_ORDER_API_ERROR"
